import { Field, Float, ID, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { Order } from '../Order'
import type { IAction } from '../../action/IAction'

@InputType()
export class FulfillOrderArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => String, { nullable: true })
  fulfilledVia?: string

  @Field(() => String, { nullable: true })
  paymentMethod?: string

  @Field(() => Date, { nullable: true })
  date?: Date

  @Field(() => String, { nullable: true })
  remarks?: string

  @Field(() => GraphQLJSON, { nullable: true })
  stripeInfo?: any

  @Field(() => Float, { nullable: true })
  paymentFee?: number

  @Field(() => Float, { nullable: true })
  paymentNet?: number

  @Field(() => Float, { nullable: true })
  paymentGross?: number

  @Field(() => String, { nullable: true })
  paymentStatus?: string

  @Field(() => String, { nullable: true })
  paymentId?: string

  @Field(() => String, { nullable: true })
  relatedOrderId?: string

  @Field(() => String, { nullable: true })
  checkNumber?: string

  @Field(() => Date, { nullable: true })
  checkDate?: Date
}

export interface IFullfillOrder extends IAction<Order, FulfillOrderArgs> {}
